import { all, AllEffect, fork } from "redux-saga/effects";
// import { actionWatcher } from '../saga/activity/activitySaga';
import {
  getActivitiesFeedbackWatcher,
  getResidentsActivitiesWatcher,
  getResidentsConfigurationsWatcher,
  sendResidentActivityWatcher,
} from "../saga/activityPlan/activityPlanSaga";
import { getAlertsFromResidentsWatcher } from "../saga/alerts/alertsSaga";
import {
  getAuthDataWatcher,
  logoutNewWatcher,
  rotateTokenWatcher,
  signInPasswordlessEndWatcher,
  signInPasswordlessWatcher,
  signInWatcher,
  singInCheckWatcher,
} from "../saga/auth/authorizationSaga";
import {
  getDevicesStatusesWatcher,
  getDevicesWatcher,
  getUserTagDevicesWatcher,
  getVitalsUserNearbySettingsWatcher,
  getVitalsUserNearbyWatcher,
} from "../saga/devices/devicesSaga";
import {
  cleanIfForbiddenSubscribeWatcher,
  notifyLoginLogoutWatcher,
  registerMobileDeviceAsTagWatcher,
  subscribeWatcher,
  unregisterMobileDeviceAsTagWatcher,
  unsubscribeWatcher,
  updateSubscribeWatcher,
} from "../saga/healthCheck/healthCheckSaga";

import {
  getFeedbackByAlertTypeWatcher,
  setAlertByTypeWatcher,
} from "../saga/modalFeedback/feedbackSaga";
import {
  getAllNodesInfoWatcher,
  getDetailsWatcher,
  getOrganizationWatcher,
} from "../saga/organization/organizationSaga";
import { getRepeatAlertsWatcher } from "../saga/repeatAlert/repeatAlertSaga";
import {
  getResidentsStuffWatcher,
  getResidentsWatcher,
} from "../saga/residents/residentsSaga";

import {
  changeUserLanguageWatcher,
  changeUserNotificationWatcher,
  usersProfileWatcher,
} from "../saga/userProfile/usersProfileSaga";
import {
  getUserMobileDeviceWatcher,
  getUsersPictures,
  getUsersWatcher,
} from "../saga/users/usersSaga";
import { sendUserActivityWatcher } from "../saga/activity/activitySaga";
export default function* rootSaga(): Generator<AllEffect<any>, void, unknown> {
  yield all([
    fork(rotateTokenWatcher),
    fork(getAuthDataWatcher),
    fork(logoutNewWatcher),
    fork(signInPasswordlessEndWatcher),
    fork(signInPasswordlessWatcher),
    fork(signInWatcher),
    fork(singInCheckWatcher),

    fork(getActivitiesFeedbackWatcher),
    fork(getResidentsActivitiesWatcher),
    fork(getResidentsConfigurationsWatcher),
    fork(sendResidentActivityWatcher),

    fork(getAlertsFromResidentsWatcher),

    fork(getDevicesStatusesWatcher),
    fork(getDevicesWatcher),
    fork(getUserTagDevicesWatcher),
    fork(getVitalsUserNearbySettingsWatcher),
    fork(getVitalsUserNearbyWatcher),

    fork(cleanIfForbiddenSubscribeWatcher),
    fork(notifyLoginLogoutWatcher),
    fork(registerMobileDeviceAsTagWatcher),
    fork(subscribeWatcher),
    fork(unregisterMobileDeviceAsTagWatcher),
    fork(unsubscribeWatcher),
    fork(updateSubscribeWatcher),

    fork(getFeedbackByAlertTypeWatcher),
    fork(setAlertByTypeWatcher),

    fork(getAllNodesInfoWatcher),
    fork(getDetailsWatcher),
    fork(getOrganizationWatcher),

    fork(getRepeatAlertsWatcher),

    fork(getResidentsStuffWatcher),
    fork(getResidentsWatcher),

    fork(changeUserLanguageWatcher),
    fork(changeUserNotificationWatcher),
    fork(usersProfileWatcher),

    fork(getUserMobileDeviceWatcher),
    fork(getUsersPictures),
    fork(getUsersWatcher),

    fork(sendUserActivityWatcher),
  ]);
}
